<template>
  <v-container fluid>
    <div class="text-right margin-bottom-2x">
      <v-btn outlined color="primary" @click.stop="AddApp"> <v-icon left>mdi-plus</v-icon>新增 </v-btn>
    </div>
    <!-- <p v-for="(item, i) in tableData" :key="i"> {{item.appName}}</p> -->
    <v-data-table :headers="headers" :items="tableData" :loading="loading" class="elevation-1" :hide-default-footer="false">
      <template v-slot:[`item.appIconUrl`]="{ item }">
        <!-- <span>{{item.extraConfig.img[0].src}}</span> -->
        <v-avatar class="img" size="36" v-if="item">
          <img :src="imgSrcTimestamp(item.extraConfig.img[0].src)" :onerror="defaultAppIcon" />
        </v-avatar>
      </template>
      <template v-slot:[`item.appUserType`]="{ item }">
        <span v-if="item.appUserType === 'common'">
          <span v-for="(subItem, i) in userTypeList" :key="i">
            <!-- {{ subItem }} -->
            {{ subItem.name }}
            <span v-if="i + 1 < userTypeList.length">&nbsp;/&nbsp;</span>
          </span>
        </span>
        <span v-else>
          {{ userTypeList.find(e => e.label === item.appUserType).name }}
          <!-- {{ userTypeList.find(e => e.label === item.appUserType) }} -->
        </span>
      </template>
      <template v-slot:[`item.platType`]="{ item }">
        <!-- <span>{{ item.platType }}</span> -->
        <!-- <span>{{ platTypeLevel }}</span> -->
        <div v-if="item.platType">
          <!-- <span v-for="(ele, i) in item.platType.split(',')" :key="i"> {{ platTypeLevel.find((e) => e.code === ele).name }} &nbsp;&nbsp; </span> -->
          <span v-for="(ele, i) in item.platType.split(',')" :key="i"> {{ platTypeList.find((e) => e.code === ele).name }} &nbsp;&nbsp; </span>
        </div>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn class="ma-2 white--text" small color="blue" @click="clickAction(item, 'detail')">查看</v-btn>
        <v-btn class="ma-2 white--text" small color="error" @click="clickAction(item, 'delete')">移除</v-btn>
      </template>
      <template v-slot:[`item.others`]="">
        <div class="pointer">
          <v-icon right>mdi-menu</v-icon>
        </div>
      </template>
    </v-data-table>
    <v-dialog v-model="addDialog" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">选择绑定应用</span>
        </v-card-title>
        <v-data-table v-model="selected" :headers="headersAdd" :items="allAppList" :single-select="false" item-key="appCode" selectable-key="isSelectable" show-select :loading="addLoading" :options.sync="pagination" :server-items-length="totalDesserts">
          <!-- 'indigo--text', 'deep-orange--text', 'teal--text' -->
          <template v-slot:[`item.isSelectable`]="{ item }">
            <span :class="item.isSelectable ? 'blue--text' : 'green--text'"> {{ item.isSelectable ? "未绑定" : "已绑定" }}</span>
          </template>
          <template v-slot:[`item.appIconUrl`]="{ item }">
            <v-avatar class="img" size="36">
              <img :src="imgSrcTimestamp(item.extraConfig.img[0].src)" :onerror="defaultAppIcon" />
            </v-avatar>
          </template>
          <template v-slot:[`item.appUserType`]="{ item }">
              <!-- <span>{{ item.appUserType }}</span> -->
              <span v-if="item.appUserType === 'common'">
                <span v-for="(subItem, i) in userTypeList" :key="i">
                  <!-- {{ subItem }} -->
                  {{ subItem.name }}
                  <span v-if="i + 1 < userTypeList.length">&nbsp;/&nbsp;</span>
                </span>
              </span>
              <span v-else>
                {{ userTypeList.find(e => e.label === item.appUserType).name }}
                <!-- {{ userTypeList.find(e => e.label === item.appUserType) }} -->
              </span>
            <!-- <span v-if="item.appUserType"> {{ userTypeList.find((e) => e.label === item.appUserType).name }} </span> -->
          </template>
          <template v-slot:[`item.platType`]="{ item }">
            <!-- <span>{{ item.platType }}</span> -->
            <!-- <span>{{ platTypeLevel }}</span> -->
            <div v-if="item.platType">
              <!-- <span v-for="(ele, i) in item.platType.split(',')" :key="i"> {{ platTypeLevel.find((e) => e.code === ele).name }} &nbsp;&nbsp; </span> -->
              <span v-for="(ele, i) in item.platType.split(',')" :key="i"> {{ platTypeList.find((e) => e.code === ele).name }} &nbsp;&nbsp; </span>
            </div>
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="" @click="addDialog = false" text> 取消 </v-btn>
          <v-btn color="primary" @click="confirmAdd(null)" text :disabled="selected.length === 0"
            >确认添加
            <span v-if="selected.length > 0"> ({{ selected.length }}) </span>
          </v-btn>
        </v-card-actions>
      </v-card>

      <!-- <template v-slot:top>
          <v-switch
            v-model="singleSelect"
            label="Single select"
            class="pa-3"
          ></v-switch>
        </template> -->

      <!-- <v-btn  class="ma-2 white--text" @click="confirmAdd"> 确认添加
        <span v-if="selected.length > 0"> ({{selected.length}}) </span>
      </v-btn> -->
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">移除应用</span>
        </v-card-title>
        <v-card-text class="pb-0"> 确定要在组件中移除应用- {{ currentItem.appName }}({{ currentItem.appCode }})？<br /> </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="normal" @click="deleteDialog = false" text>取消</v-btn>
          <v-btn color="error" @click="deleteItem" text>确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { buildAxios } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'
import { imgSrcTimestamp } from '@/plugins/utils'
import Sortable from 'sortablejs'
const request = buildAxios()
export default {
  name: 'AppInfo',
  components: {
  },
  props: ['data'],
  data () {
    return {
      totalDesserts: 0,
      loading: false,
      headers: [
        { text: '图标', value: 'appIconUrl' },
        { text: 'appCode', value: 'appCode' },
        { text: '名称', value: 'appName' },
        { text: '用户类型', value: 'appUserType' },
        { text: '平台类型', value: 'platType' },
        { text: '英文名称', value: 'appNameEn' },
        { text: '操作', value: 'actions' },
        { text: '顺序', value: 'others' }
      ],
      sortData: [], // 排序数据
      tableData: [], // 表格显示数据
      allAppList: [],
      deleteDialog: false,
      currentItem: {},
      obj: {
        aaa: '1111'
      },
      defaultAppIcon: 'this.src="' + require('@/assets/icon/example.svg') + '"',
      singleSelect: false,
      selected: [],
      headersAdd: [
        { text: '安装状态', value: 'isSelectable' },
        { text: '图标', value: 'appIconUrl' },
        { text: 'appCode', value: 'appCode' },
        { text: '名称', value: 'appName' },
        { text: '英文名称', value: 'appNameEn' },
        { text: '用户类型', value: 'appUserType' },
        { text: '平台类型', value: 'platType' }
        // { text: '操作', value: 'actions' }
        // { text: '顺序', value: 'others' }
      ],
      addDialog: false,
      addLoading: false,
      pagination: { page: 1, itemsPerPage: 10 }
    }
  },
  computed: {
    ...mapState(['userTypeList', 'platTypeLevel', 'platTypeList'])
  },
  watch: {
    pagination: {
      handler (val) {
        console.log('pagination', val)
        this.getAllAppList()
      },
      deep: true
    }
  },
  created () {
  },
  mounted () {
    this.getComBindApp()
    this.initSortable()
  },
  methods: {
    imgSrcTimestamp,
    initSortable () {
      // const that = this
      const tbody = document.querySelector('.v-data-table__wrapper tbody')
      Sortable.create(tbody, {
        animation: 200,
        onEnd: (e) => {
          console.log(e, e.oldIndex, e.newIndex)
          const arr = JSON.parse(JSON.stringify(this.sortData)) // 获取表数据
          arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]) // 数据处理
          // const sss = []
          // arr.forEach(element => {
          //   sss.push(element.appName)
          // })
          // console.log(arr, sss.join(','))
          this.sortData = arr
          this.confirmAdd(this.sortData)
        }
      })
    },
    AddApp () {
      console.log(1)
      // this.getAllAppList()
      this.addDialog = true
      // this.$router.push({ name: 'appAdd' })
    },
    // 获取全部应用
    getAllAppList () {
      // const request = buildAxios()\
      this.addLoading = true
      request.get('baseApp/page?page=' + (this.pagination.page - 1) + '&size=' + this.pagination.itemsPerPage + '&platType=' + this.data.platType)
        .then(res => {
          this.addLoading = false
          this.totalDesserts = res.data.data.totalSize
          this.allAppList = res.data.data.data || []
          this.allAppList.forEach(element => {
            // console.log(this.sortData.findIndex(item => item.appCode === element.appCode))
            const i = this.sortData.findIndex(item => item.appCode === element.appCode)
            if (i > -1) {
              this.$set(element, 'isSelectable', false)
            } else {
              this.$set(element, 'isSelectable', true)
            }
          })
          console.log(this.allAppList)
        })
        .catch(reason => {
          this.addLoading = false
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    // 获取组件绑定应用
    getComBindApp () {
      // const request = buildAxios()
      console.log('comCode', this.data)
      this.loading = true
      request.get('baseComponentBindApp/listAppByComCode?comCode=' + this.data.comCode)
        .then(res => {
          this.loading = false
          this.tableData = res.data.data || []
          this.sortData = res.data.data || []
          // console.log(this.allAppList)
        })
        .catch(reason => {
          this.loading = false
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
        })
    },
    // /cloud-api/baseComponentBandApp/listAppByComCode
    // action
    clickAction (item, type) {
      this.currentItem = item
      localStorage.setItem('appDetail', JSON.stringify(item))
      if (type === 'detail') {
        this.$router.push({ name: 'appDetail', query: { appCode: item.appCode } })
      } else if (type === 'edit') {
        this.$router.push({ name: 'appAdd', query: { appCode: item.appCode } })
      } else if (type === 'delete') {
        this.deleteDialog = true
      }
    },
    // delete
    deleteItem () {
      // console.log()
      const index = this.tableData.findIndex(item => item.appCode === this.currentItem.appCode)
      // const indexSort = this.sortData.findIndex(item => item.appCode === this.currentItem.appCode)
      this.tableData.splice(index, 1)
      // this.sortData.splice(indexSort, 1)
      console.log(this.tableData, this.sortData, this.currentItem)
      // this.tableData.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0])
      // this.tableData.
      // const request = buildAxios()
      // request.post('baseApp/delete', { appCode: this.currentItem.appCode }).then(res => {
      this.deleteDialog = false
      this.confirmAdd(this.sortData)
      //   this.getList()
      // }).catch(reason => {
      //   this.$emit('alert', {
      //     msg: handleResponse(reason.response),
      //     type: 'error'
      //   })
      // })
    },
    confirmAdd (data) {
      const arr = []
      let appData = []
      //  = data || this.selected
      if (data) {
        appData = data
      } else {
        appData = this.selected.concat(this.sortData)
        console.log('追加', this.sortData, this.selected, appData)
      }
      // console.log(arr, appData)
      appData.forEach(element => {
        arr.push(element.appCode)
      })
      // console.log({ comCode: this.data.comCode, appCodeList: arr })
      // console.log('confirmAdd', this.selected, { comCode: this.data.comCode, appCodeList: arr })
      request.post('/baseComponentBindApp/save', { comCode: this.data.comCode, appCodeList: arr }).then(res => {
        // this.deleteDialog = false
        // this.getList()
        if (!data) this.getComBindApp()
        this.addDialog = false
        this.$emit('alert', {
          msg: handleResponse(res.msg),
          type: 'success'
        })
      }).catch(reason => {
        this.getComBindApp()
        this.$emit('alert', {
          msg: handleResponse(reason.response),
          type: 'error'
        })
      })
    }
  },
  filters: {
  }
}
</script>
